import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../utils/authService';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();
  const user = authService.getUser();

  console.log('🔒 ProtectedRoute check:', {
    isAuthenticated,
    user,
    requiredRole,
    currentPath: location.pathname
  });

  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated || !user) {
    console.log('❌ Not authenticated, redirecting to login');
    return <Navigate to={`/login?returnUrl=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // If role is required, check if user has it (handle both formats)
  if (requiredRole) {
    const userRole = user?.role;
    const normalizedUserRole = userRole?.toUpperCase()?.startsWith('ROLE_') ? userRole?.toUpperCase() : `ROLE_${userRole?.toUpperCase()}`;
    const normalizedRequiredRole = requiredRole?.toUpperCase()?.startsWith('ROLE_') ? requiredRole?.toUpperCase() : `ROLE_${requiredRole?.toUpperCase()}`;
    
    console.log('🔒 Role check:', {
      userRole,
      normalizedUserRole,
      requiredRole,
      normalizedRequiredRole,
      hasAccess: normalizedUserRole === normalizedRequiredRole
    });
    
    if (normalizedUserRole !== normalizedRequiredRole) {
      console.log('❌ Insufficient role permissions, redirecting to dashboard');
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;